<template>
    <div>
        <div class="modal-backdrop fade in"
             style="position: absolute; background-color: #fff !important; opacity: .8"
             v-if="state"
             @click="hide()"></div>
        <div class="modal fade in"
             tabindex="-1"
             role="dialog"
             style="position: absolute; display: block;"
             :style="modalStyle"
             @click="hideFromModal"
             v-el:modal>
            <div class="modal-dialog" role="document" v-bind:style="{'width': width + 'px'}">
                <div class="modal-content"
                     style="border-radius: 0; box-shadow: 0 0px 20px rgba(0, 0, 0, 0.1); border: 1px solid rgba(0, 0, 0, 0.1);">
                    <div class="modal-header">
                        <button class="new-close" type="button" @click="hide()" title="Fechar (ESC)" v-tooltip>
                            &times;
                        </button>
                        <h4 class="modal-title">
                            <slot name="header">{{ title }}</slot>
                        </h4>
                    </div>
                    <div class="modal-body" :class="getBodyClass()" v-el:modal-body>
                        <slot></slot>
                    </div>
                    <div class="modal-footer">
                        <slot name="footer">
                            <button class="btn btn-default" type="button" data-dismiss="modal">{{ secondaryText }}</button>
                            <button class="btn btn-primary" type="button">{{ primaryText }}</button>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/babel">
    const $ = require('jquery')
    /**
     * A ideia é criar um modal reusável,
     * Como existem limitações no Bootstrap, onde, por exemplo, não podemos colocar um botão que
     * chama um modal dentro de um btn-group, o elemento é renderizado fora do escopo pra evitar
     * isso.
     */
    export default{
        name: 'ui-inline-modal',
        props: {
            text: {
                type: String,
                default: 'Carregando...'
            },
            onlyBlock: {
                default: false
            },
            title: {
                default: 'Default Title'
            },
            destroy: {
                default: true,
                type: Boolean
            },
            width: {
                default: 600,
                type: Number
            },
            noPaddingBody: {
                type: Boolean,
                default: false
            },
            onHidden: {
                type: Function,
                default: null
            }
        },
        data () {
            return {
                state: false
            }
        },
        ready () {
        },
        destroyed () {
        },
        methods: {
            hideFromModal (evt) {
                if (evt.target === this.$els.modal) {
                    this.hide()
                }
            },
            onEsc (evt) {
                this.hide()
            },
            show () {
                this.$root.onEsc(this.onEsc)

                return new Promise((resolve, reject) => {
                    this.$emit('show')

                    this.$nextTick(() => {
                        resolve()

                        this.$emit('shown')

                        this.focus()
                    })

                    this.state = true
                })
            },
            hide () {
                this.$root.offEsc(this.onEsc)

                return new Promise((resolve, reject) => {
                    this.$emit('hide')

                    this.$nextTick(() => {
                        resolve()

                        this.$emit('hidden')

                        if (this.onHidden) {
                            this.onHidden()
                        }
                    })

                    this.state = false
                })
            },
            getBodyClass () {
                const classes = []

                if (this.noPaddingBody) {
                    classes.push('no-padding-body')
                }

                return classes
            },
            focus () {
                const el = this.$els.modalBody.querySelector('[autofocus]')

                if (el) {
                    el.focus()
                }
            }
        },
        computed: {
            modalStyle () {
                if (this.state) {
                    return {
                        display: 'block'
                    }
                }

                return {
                    display: 'none'
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// InlineModal.vue?cb9af22c